module.exports = __webpack_public_path__ + "img/ssyx_42.eb878e27.jpg";